import React from 'react';
import { usePageSeo } from '../Seo/PageSeo';
import './TermsOfService.css';

const TermsOfService = () => {
  usePageSeo({
    title: 'Terms of Service',
    description: 'Terms governing use of Occasia’s venue booking platform for organisers and venue owners.',
    path: '/terms'
  });

  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <h1 className="legal-title">Terms of Service</h1>
        <p className="legal-updated">Last updated: 18 June 2026</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            These Terms of Service (&quot;Terms&quot;) govern your access to and use of Occasia&apos;s
            website, products, and services (collectively, the &quot;Platform&quot;). By using the
            Platform you agree to be bound by these Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. What Occasia Does</h2>
          <p>
            Occasia connects venues with organisers who are looking to host events. We provide tools
            to discover spaces, make enquiries, manage bookings, and communicate with venue owners.
            Unless explicitly stated otherwise, Occasia is not the owner, operator, or manager of
            any venue listed on the Platform.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Your Account</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account and for all
            activity that occurs under it. You agree to provide accurate information and to update
            it as needed. We may suspend or terminate your account if we suspect unauthorised use or
            breach of these Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Bookings and Payments</h2>
          <p>
            Booking enquiries made through the Platform are not confirmed until the venue owner
            accepts them and any required payments are made. Specific booking terms, including
            pricing, cancellation policies, and house rules, are set by each venue. It is your
            responsibility to review and agree to those terms before confirming a booking.
          </p>
          <p>
            Where card payments are processed through Stripe (including Stripe Connect), you
            authorise Occasia and its payment partners to charge your payment method for the
            booking amount shown at checkout. Occasia may charge a platform fee on eligible
            transactions. Stripe and other payment providers may charge separate processing fees
            in connection with your payment.
          </p>
          <p>
            <strong>Platform fees and Stripe processing fees are non-refundable.</strong> If a
            booking is cancelled, disputed, or refunded (in whole or in part), any platform fee
            retained by Occasia and any card-processing or payment fees charged by Stripe or its
            banking partners will not be returned to you, the venue, or any other party, except
            where we are required to do so by applicable law. Any refund of the underlying booking
            amount (if offered under the venue&apos;s cancellation policy or otherwise) will be
            calculated separately and may not include platform or processing fees.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Platform for any unlawful, misleading, or fraudulent purpose.</li>
            <li>Infringe the rights of others, including privacy, intellectual property, or publicity rights.</li>
            <li>Interfere with the proper functioning or security of the Platform.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Disclaimer &amp; Liability</h2>
          <p>
            The Platform is provided on an &quot;as is&quot; and &quot;as available&quot; basis. To the maximum
            extent permitted by law, Occasia disclaims all warranties, and will not be liable for
            any indirect, incidental, or consequential damages arising out of or in connection with
            your use of the Platform or any venue.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. When we make changes, we will update the
            &quot;Last updated&quot; date above. Continued use of the Platform after changes become effective
            constitutes your acceptance of the updated Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Contact</h2>
          <p>
            If you have any questions about these Terms, please contact us at{' '}
            <a href="mailto:hello@occasia.io">hello@occasia.io</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;



